import {
    AfterViewInit,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {IActionPassData, IFormItemsControls, IShadowFieldPass} from '../../../../interface/form-structure';
import {IFieldShema} from '@usteknoloji/noosgrid';

import {ActionFlag, FormItemComponentInterface, IFormDialogData, IWizardViewOutput} from '../../../../interface/component';

import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {GlobalObjectService} from '../../../../class/global-obj';
import * as _ from 'lodash';
import {FormEventService} from '../../../../services/formEventService';


@Component({
    selector: 'noos-view-app',
    templateUrl: './view-app.component.html',
    styleUrls: ['./view-app.component.scss']
})

@NoosFormTypeService.register('viewApp')
export class ViewAppComponent implements OnInit, AfterViewInit, FormItemComponentInterface {


    @ViewChild('containersub', {read: ViewContainerRef}) formContainer: ViewContainerRef;

    prop: IFormItemsControls;
    isFilter = false;
    showLoader = true;
    className = '';

    isForm = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId = 0;

    formFieldStructure: IFieldShema[];
    formRecordData: any;
    pkeys: any;
    shadowFieldValues: IShadowFieldPass[] = [];

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private noosFormTypeFactory: NoosFormTypeService, private eventListenerService: FormEventService) {
    }

    ngOnInit(): void {

        this.formFieldStructure = _.orderBy(GlobalObjectService.getVar('formFieldStructure_' + this.formId.toString()), ['list_order'], ['ASC']);
        this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());
        this.pkeys = GlobalObjectService.getVar('pkeys_' + this.formId.toString());
    }

    ngAfterViewInit(): void {
        if (this.prop.viewOptions !== undefined) {
            this.recordId = parseInt(GlobalObjectService.getVar('record_id_' + this.formId.toString()), 0);


            if (this.prop.viewOptions.appShadowFields !== undefined && this.prop.viewOptions.appShadowFields.length > 0) {
                console.log('----Shadow:', this.prop.viewOptions.appShadowFields);
                this.prop.viewOptions.appShadowFields.forEach(x => {
                    const fieldName = x.targetFieldName !== '' ? x.targetFieldName : x.sourceFieldName;
                    const isPKeys = this.pkeys.filter(f => f.source_field === x.sourceFieldName);
                    const isField = this.formFieldStructure.filter(i => i.source_field_name === x.sourceFieldName);
                    const fieldAlias = isPKeys.length > 0 ? isPKeys[0].field_alias : isField.length > 0 ? isField[0].field_alias : '';
                    if (fieldAlias !== '') {
                        const fieldValue = this.formRecordData[fieldAlias];
                        if (fieldValue !== undefined) {
                            this.shadowFieldValues.push({fieldName, fieldValue});
                        }
                    }

                });
                console.log(this.shadowFieldValues);
                console.log(this.formFieldStructure);
                console.log(this.formRecordData);
            }


            if (this.prop.viewOptions.appSetting.target_app_type === 'appview') {
                this.loadAppViewComponent('appview');
            } else {
                this.isForm = true;
                this.loadFormComponent('noosform2');
            }

            this.className = this.prop.viewOptions.cssClass !== undefined
                ? this.prop.viewOptions.cssClass.replace('.', '') : '';


        }
    }


    loadFormComponent(containerName) {


        const component = this.noosFormTypeFactory.getPostTypeFromString(containerName);
        if (component === null || component === undefined) {
            return;
        }

        let findRecordId = '';
        if (this.datasetId === this.prop.viewOptions.appSetting.target_dataset_id) {
            findRecordId = this.recordId.toString();
        } else {
            const fieldSearch = this.pkeys.filter(x => x.source_field === this.prop.options.field_name);
            if (fieldSearch.length === 0) {
                return;
            }
            const fieldName = fieldSearch[0].field_alias;
            findRecordId = this.formRecordData[fieldName];
        }


        const eventData = this.prop.viewOptions.appSetting;
        const passData: IActionPassData = {
            target_dataset_id: eventData.target_dataset_id,
            target_field_name: eventData.target_field_name,
            target_field_foreign_relation_dataset_id: eventData.target_field_foreign_relation_dataset_id,
            source_dataset_to_query_target_field_name: eventData.source_dataset_to_query_target_field_name,
            target_app: eventData.target_app,
            record_id: this.recordId,
            title: this.prop.label,
            source_dataset_id: this.datasetId,
            preQuery: this.prop.viewOptions.appPreQuery,
            new_form_id: this.prop.viewOptions.appSetting.new_form_id ? this.prop.viewOptions.appSetting.new_form_id : 0,
            new_form_text: this.prop.viewOptions.appSetting.new_form_text !== undefined ? this.prop.viewOptions.appSetting.new_form_text : '',
            disableChildControl: this.prop.viewOptions.appSetting.disableChildControl !== undefined
                ? this.prop.viewOptions.appSetting.disableChildControl : false,
            shadowFieldValues: this.shadowFieldValues
        };

        const dialogData: IFormDialogData = {
            setting: GlobalObjectService.getVar('setting'),
            formId: this.prop.viewOptions.appSetting.target_app,
            formJson: null,
            actionFlag: ActionFlag.EDIT,
            API_URLS: null,
            workFlowObjectId: '',
            recordId: parseInt(findRecordId, 0),
            actionPassedData: passData,
            liveValue: this.prop.viewOptions.appSetting.liveValue !== undefined
                ? this.prop.viewOptions.appSetting.liveValue : false,
        };


        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        // this.formContainer.clear();
        const componentRef = this.formContainer.createComponent(componentFactory);
        // componentRef.instance.inData = dialogData;
        // @ts-ignore
        componentRef.instance.setUpData(dialogData, false);
        componentRef.changeDetectorRef.detectChanges();


    }

    loadAppViewComponent(containerName) {
        const component = this.noosFormTypeFactory.getPostTypeFromString(containerName);


        const eventData = this.prop.viewOptions.appSetting;
        const passData: IActionPassData = {
            target_dataset_id: eventData.target_dataset_id,
            target_field_name: eventData.target_field_name,
            target_field_foreign_relation_dataset_id: eventData.target_field_foreign_relation_dataset_id,
            source_dataset_to_query_target_field_name: eventData.source_dataset_to_query_target_field_name,
            target_app: eventData.target_app,
            record_id: this.recordId,
            title: this.prop.label,
            source_dataset_id: this.datasetId,
            preQuery: this.prop.viewOptions.appPreQuery,
            new_form_id: this.prop.viewOptions.appSetting.new_form_id ? this.prop.viewOptions.appSetting.new_form_id : 0,
            new_form_text: this.prop.viewOptions.appSetting.new_form_text !== undefined ? this.prop.viewOptions.appSetting.new_form_text : '',
            disableChildControl: this.prop.viewOptions.appSetting.disableChildControl !== undefined
                ? this.prop.viewOptions.appSetting.disableChildControl : false,
            shadowFieldValues: this.shadowFieldValues
        };

        if (component === null || component === undefined) {
            return;
        }

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        this.formContainer.clear();
        const componentRef = this.formContainer.createComponent(componentFactory);
        // @ts-ignore
        componentRef.instance.dataObject = passData;

        // @ts-ignore
        componentRef.instance.eventAddNewRecord.subscribe(ret => {
            console.log('eventAddNewRecord:', ret, containerName);

            this.eventListenerService.updatedDataSelection({
                fromComponentId: this.prop.id,
                fromComponentName: this.prop.name,
                eventName: 'add',
                triggerValue: ret,
                formId: this.formId,
                datasetId: this.datasetId
            });

        });

        componentRef.changeDetectorRef.detectChanges();

    }

}
